var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 0C5.8203 0 0 5.59644 0 12.5C0 19.4036 5.8203 25 13 25C20.1797 25 26 19.4036 26 12.5C26 5.59644 20.1797 0 13 0ZM14.1384 13.049V19.8496H11.212V13.0493H9.75004V10.7057H11.212V9.29865C11.212 7.38679 12.0376 6.24992 14.383 6.24992H16.3357V8.59373H15.1151C14.2021 8.59373 14.1417 8.92124 14.1417 9.53248L14.1384 10.7054H16.3495L16.0908 13.049H14.1384Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"26","height":"25","viewBox":"0 0 26 25","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
